import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IEquipmentType, IRealEstate, ITypeTechnicalRoom } from './interfaces';

export const getTypeTechnicalRoomList = (params: IDynamicTableParams): Promise<ITypeTechnicalRoom[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/typeTechnicalRoom/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getTypeTechnicalRoomListAll = () => {
  return instance(true, PPR_API_URL)
    .get<ITypeTechnicalRoom[]>('/dictionary/typeTechnicalRoom/listAll')
    .then((response) => response.data);
};

export const getTypeTechnicalRoomListByRealEstate = (realEstateId: string) => {
  return instance(true, PPR_API_URL)
    .get<ITypeTechnicalRoom[]>(`/dictionary/typeTechnicalRoom/list/${realEstateId}`)
    .then((response) => response.data);
};

export const getTypeTechnicalRoomAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/dictionary/typeTechnicalRoom/availableColumns')
    .then((response) => response.data);
};

export const getTypeTechnicalRoomAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/dictionary/typeTechnicalRoom/availableGroupColumns')
    .then((response) => response.data);
};

export const loadTypeTechnicalRoom = (typeTechnicalRoomId: number) => {
  return instance(true, PPR_API_URL)
    .get<ITypeTechnicalRoom>(`/dictionary/typeTechnicalRoom/load/${typeTechnicalRoomId}`)
    .then((response) => response.data);
};

export const createTypeTechnicalRoom = (typeTechnicalRoom: ITypeTechnicalRoom) => {
  return instance(true, PPR_API_URL)
    .post<ITypeTechnicalRoom>(`/dictionary/typeTechnicalRoom/create`, typeTechnicalRoom)
    .then((response) => response.data);
};

export const updateTypeTechnicalRoom = (typeTechnicalRoomId: number, typeTechnicalRoom: ITypeTechnicalRoom) => {
  return instance(true, PPR_API_URL)
    .post<ITypeTechnicalRoom>(`/dictionary/typeTechnicalRoom/update/${typeTechnicalRoomId}`, typeTechnicalRoom)
    .then((response) => response.data);
};

export const archiveTypeTechnicalRoom = (typeTechnicalRoomId: number, isDeleted: boolean) => {
  return instance(true, PPR_API_URL)
    .post('/dictionary/typeTechnicalRoom/deleted/' + typeTechnicalRoomId, { isDeleted })
    .then((response) => response.data);
};

export const getEquipmentTypeListAll = () => {
  return instance(true, PPR_API_URL)
    .get<IEquipmentType[]>('/dictionary/equipmentType/listAll')
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { includeUnserved?: boolean; includeDeleted?: boolean; searchWithCity?: boolean; nameWithCity?: boolean } = {
    includeUnserved: true,
    includeDeleted: false,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) =>
      response.data.map((realEstate) => ({
        ...realEstate,
        realEstateName: realEstate.name,
        realEstateId: realEstate.guid,
      })),
    );
};
